import {createAction, createReducer} from "@reduxjs/toolkit";
import {getDefaultHandler, getDefaultState} from "../Utils/newReducerTools";
import ProxiesService from "../Services/ProxiesService";


export const getProxies = createAction('/proxies', () => ({
    payload: ProxiesService.getProxies()
}))
export const changeProxies = createAction('/proxies-edit', (params) => ({
    payload: ProxiesService.editProxies(params)
}))
export const createProxies = createAction('/proxies-create', (params) => ({
    payload: ProxiesService.createProxies(params)
}))

const initialState = {
    proxies: getDefaultState(),
    createProxies: getDefaultState(),
    editProxies: getDefaultState(),
}

export default  createReducer(initialState, {
    ...getDefaultHandler(getProxies, 'proxies'),
    ...getDefaultHandler(createProxies, 'createProxies'),
    ...getDefaultHandler(changeProxies, 'editProxies')
})
